"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [_c("app-select", {
    attrs: {
      label: "Selecione o Cliente (Comprador)",
      placeholder: "Cliente",
      items: _vm.listCustomers,
      option: "id",
      "name-item": "name",
      expanded: ""
    },
    model: {
      value: _vm.selectedCostumer,
      callback: function callback($$v) {
        _vm.selectedCostumer = $$v;
      },
      expression: "selectedCostumer"
    }
  }), _vm._v(" "), _c("b-button", {
    staticClass: "btn-add-field",
    on: {
      click: _vm.openModalNewCustomer
    }
  }, [_vm._v("\n    Novo cliente +\n  ")])], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;